<template>
  <Dialog :title="title" :loading="loading" confirm="Fortsæt" @close="onClose">
    <template #content>
      <FguTable
        v-if="timeRegistrations?.length"
        class="mt-4"
        :loading="$apollo.queries.timeRegistrations.loading"
        :columns="['date', 'minutes', 'humanCategory', 'project.name']"
        :rows="timeRegistrations || []"
        :headings="{
          'project.name': 'Projekt',
          date: 'Dato',
          minutes: 'Timer',
          humanCategory: 'Kategori',
        }"
        :dateColumns="['date']"
      >
        <template #minutes="{ row }">
          <span class="flex items-center">
            {{ $filters.formatMinutes(row.minutes) }}
          </span>
        </template>
        <template #beforeHeaderLeft>
          <AlertBox type="warning" class="mb-4"> Følgende godkendte tidsregistreringer vil blive nulstillet! </AlertBox>
        </template>
      </FguTable>
      <p v-else-if="$apollo.queries.timeRegistrations.loading" class="flex items-center justify-center h-full">
        <BaseSpinner size="lg" />
      </p>
      <p v-else class="text-sm text-gray-700" v-html="body"></p>
    </template>
  </Dialog>
</template>

<script>
import gql from "graphql-tag";
import Dialog from "~/components/dialogs/Dialog";
import FguTable from "~/components/fgu-table/FguTable";
import AlertBox from "~/components/shared/AlertBox";

export const sickNoteQuery = gql`
  query sickNote($id: ID!, $startDate: ISO8601Date!, $endDate: ISO8601Date!) {
    sickNote(id: $id) {
      id
      timeRegistrations(startDate: $startDate, endDate: $endDate) {
        id
        date
        minutes
        humanCategory
      }
    }
  }
`;

export default {
  components: { AlertBox, FguTable, Dialog },

  props: {
    title: { type: String, required: true },
    body: { type: String, required: true },
    confirm: { type: String, default: "Slet" },
    cancel: { type: String, default: "Annuller" },
    sickNote: {
      type: Object,
      required: true,
    },
  },

  emits: ["close"],

  data() {
    return {
      loading: false,
    };
  },

  apollo: {
    timeRegistrations: {
      query: sickNoteQuery,
      variables() {
        return {
          id: this.sickNote.id,
          startDate: this.sickNote.startDate,
          endDate: this.sickNote.endDate,
        };
      },

      update(data) {
        if (!data?.sickNote?.timeRegistrations?.length) {
          this.onClose(true);
          return [];
        }

        return data.sickNote.timeRegistrations.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
      },
    },
  },

  methods: {
    onClose(accepted) {
      this.$emit("close", accepted);
    },
  },
};
</script>
